import { SET_THEME } from './type'

export const setTheme = value => {
    return {
        type: SET_THEME,
        payload: value
    }
}